import { Badge, Dropdown } from "react-bootstrap";
import React, { useState } from "react";
import moment from "moment";
import NoteModal from "./Modals/NoteModal";

type CustomToggleProps = {
    children: React.ReactNode;
    onClick: (...arg: any[]) => void;
    faName: string;
    style?: React.CSSProperties;
}

type DocumentRowProps = {
    FileName: string;
    FileType: "Project" | "Unit" | "Buyer";
    Timestamp: string;
    Link: string;
    DocID?: number;
    MsgID?: string;
    SessionID: string;
    setDeleteModal: ({ }: { show: boolean, dname: string, docID: number, msgID: string }) => void;
    Note?: string;
}

const CustomToggle = React.forwardRef<HTMLInputElement, CustomToggleProps>(
    (props, ref) => (
        <i className={props.faName}
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                props.onClick(e);
            }}
            style={(props.style === undefined) ? {} : props.style}>
            {props.children}
        </i>
))

const BuilderDocumentRow = ({
    FileName,
    FileType,
    Timestamp,
    Link,
    DocID,
    MsgID,
    SessionID,
    setDeleteModal,
    Note
}: DocumentRowProps) => {
    const [showNoteModal, setShowNoteModal] = useState(false);
    function dateStr(timeStr: string): string {
        return moment(timeStr).format('D/MMM/YYYY H:mm:ss').toUpperCase();
    }

    return (<>
        <NoteModal show={showNoteModal} setShow={setShowNoteModal} note={Note} />
        <tr onClick={(e) => { window.open(process.env.REACT_APP_DSAPI_ENDPOINT + Link + `&SessionID=${SessionID}`) }}>
            <td>
                <i className="fa-solid fa-file-pdf"></i>
            </td>

            <td>{FileName}</td>
            {FileType === 'Project' && 
                <td><Badge bg="secondary" text="white" pill>{FileType}</Badge></td>
            }
            {FileType === 'Unit' && 
                <td><Badge bg="info" text="dark" pill>{FileType}</Badge></td>
            }
            {FileType === 'Buyer' && <td></td>}
            <td><span style={{fontSize: '12px', color: 'var(--txt-20)'}}>{dateStr(String(Timestamp))}</span></td>
            
            <td className="align-right" onClick={(e) => { e.stopPropagation() }}>
                {Note && Note > "" &&
                    <i className="fa-light fa-message-lines"
                        style={{ paddingRight: '15px' }}
                        onClick={() => setShowNoteModal(true)} 
                        title="Note"
                    />
                }
                <a href={process.env.REACT_APP_DSAPI_ENDPOINT + Link + `&SessionID=${SessionID}`} download={FileName}>
                    <i className="fa-light fa-arrow-down-to-line"
                        style={{ paddingRight: "15px" }}
                        title="Download document">
                    </i>
                </a>
                {
                    FileType === 'Buyer' &&
                        <Dropdown drop='down-centered' className="options" style={{ display: "inline" }}>
                            <Dropdown.Toggle as={CustomToggle} faName="fa-light fa-ellipsis" />
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={(e) => {
                                    setDeleteModal({show: true, dname: FileName, docID: DocID, msgID: MsgID});
                                }}>Delete</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                }
            </td>
        </tr>
        </>
    )
}

export default BuilderDocumentRow;